var _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPeakPerformance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 133.863,
    height: 116.142,
    viewBox: "0 0 133.863 116.142",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_55818",
    "data-name": "Group 55818",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_56443",
    "data-name": "Group 56443"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_87519",
    "data-name": "Path 87519",
    d: "M55.357,27.841a35.383,35.383,0,0,1-11.449-2.674,25.389,25.389,0,0,1-7.5,6.549,6.8,6.8,0,0,0,5.88,3.431h1.761a11.7,11.7,0,0,1,9.772,5.235l11.625,17.4a4.509,4.509,0,0,0,8.272-2.466V41.337A27.418,27.418,0,0,1,55.357,27.841Z",
    transform: "translate(21.401 56.332)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87520",
    "data-name": "Path 87520",
    d: "M59.767,44.448a10.016,10.016,0,0,0,1.409.067,18.822,18.822,0,0,0,19.587-17.9c0-.461-.053-.93-.092-1.409-.352.018-.68.053-1.025.053a20.577,20.577,0,0,1-11.914-3.8A35.379,35.379,0,0,1,44.08,36.776a22.194,22.194,0,0,0,12.347,7.179A17.815,17.815,0,0,0,59.767,44.448Z",
    transform: "translate(40.749 46.965)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87521",
    "data-name": "Path 87521",
    d: "M22.466,50.7c0,.028-.025.4-.028.43A18.2,18.2,0,0,0,43.222,69.451a3.567,3.567,0,0,1,.469-.032,3.523,3.523,0,0,1,3.442,2.772,18.382,18.382,0,0,0,33.882,5.115,3.523,3.523,0,0,1,4.721-1.353A28.183,28.183,0,0,0,124.388,63.42a3.523,3.523,0,0,1,5.823-.793,13.415,13.415,0,1,0,13.88-21.581,3.523,3.523,0,0,1-2.54-3.8,23.7,23.7,0,0,0,.169-2.663,23.057,23.057,0,0,0-22.007-22.941,3.523,3.523,0,0,1-2.237-.951A23.42,23.42,0,0,0,93.07,5.945a3.523,3.523,0,0,1-3.47-.528,16.275,16.275,0,0,0-20.563.564,3.523,3.523,0,0,1-4.185.373,13.5,13.5,0,0,0-19.273,5.7,3.491,3.491,0,0,1-3.523,2c-.426-.039-.856-.063-1.3-.063A13.436,13.436,0,0,0,27.278,27.35c0,.021.025.409.028.426a3.523,3.523,0,0,1-1.518,3.079A13.337,13.337,0,0,0,20,41.8a13.2,13.2,0,0,0,1.959,6.9A3.523,3.523,0,0,1,22.466,50.7ZM55.228,37.147A7.046,7.046,0,0,1,62.274,30.1h7.046V23.056a7.046,7.046,0,0,1,7.046-7.046h7.046a7.046,7.046,0,0,1,7.046,7.046V30.1H97.5a7.046,7.046,0,0,1,7.046,7.046v7.046A7.046,7.046,0,0,1,97.5,51.238H90.456v7.046a7.046,7.046,0,0,1-7.046,7.046H76.365a7.046,7.046,0,0,1-7.046-7.046V51.238H62.274a7.046,7.046,0,0,1-7.046-7.046Z",
    transform: "translate(-20 -2.033)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87522",
    "data-name": "Path 87522",
    d: "M46.091,32.66V43.228h7.046V32.66a3.523,3.523,0,0,1,3.523-3.523H67.228V22.091H56.66a3.523,3.523,0,0,1-3.523-3.523V8H46.091V18.568a3.523,3.523,0,0,1-3.523,3.523H32v7.046H42.568A3.523,3.523,0,0,1,46.091,32.66Z",
    transform: "translate(10.273 13.023)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeakPerformance);
export default __webpack_public_path__ + "static/media/peakPerformance.bb854b318979ae5df9e4e1f4f0d7035d.svg";
export { ForwardRef as ReactComponent };